// ReactivateSubscriptionModal Component
// Confirmation modal for reactivating a subscription scheduled to cancel

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';

export function ReactivateSubscriptionModal({
  isOpen,
  onClose,
  onConfirm,
  message = "Your subscription is scheduled to cancel. Would you like to reactivate it?",
}) {
  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Reactivate Subscription"
      showCloseButton={false}
    >
      <div style={{ padding: '20px' }}>
        <p style={{ 
          marginBottom: '24px', 
          color: '#fff', 
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          {message}
        </p>
        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          justifyContent: 'flex-end' 
        }}>
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="primary"
            onClick={handleConfirm}
          >
            Reactivate
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default ReactivateSubscriptionModal;
